import { AppRouteProps } from "@harea/component";

import React from "react";



const DetailsContainer = React.lazy(() => import('./containers/UserOrganisationDetailsAbout'))



export const DetailsRoutes: Array<AppRouteProps> = [

    {
        path: '',
        roles: ["PERSONAL_FILE_VIEW"],
        title: "Generic.UserOrganisation.About.title",
        element: <DetailsContainer />
    }

]